const ACTIONS = {
  DATA_LOADING: "DATA_LOADING",
  SET_USER_DATA: "SET_USER_DATA",
  SET_ALL_CHATS: "SET_ALL_CHATS",
  UPDATE_ALL_CHATS_LIST: "UPDATE_ALL_CHATS_LIST",
  SET_ALL_GROUP_CHATS: "SET_ALL_GROUP_CHATS",
  SET_ACTIVE_CHAT: "SET_ACTIVE_CHAT",
  UPDATE_ACTIVE_CHAT_DATA: "UPDATE_ACTIVE_CHAT_DATA",
  UPDATE_ACTIVE_CHAT_LIST: "UPDATE_ACTIVE_CHAT_LIST",
  UPDATE_ACTIVE_CHAT_USER: "UPDATE_ACTIVE_CHAT_USER",
  UPDATE_DELETED_CHAT_MESSAGE: "UPDATE_DELETED_CHAT_MESSAGE",
  UPDATE_EDITED_CHAT_MESSAGE: "UPDATE_EDITED_CHAT_MESSAGE",
  UPDATE_CHATS: "UPDATE_CHATS",
  FILTER_CHATS: "FILTER_CHATS",
  SET_AUTH_TOKENS: "SET_AUTH_TOKENS",
  ADD_WAITING_ROOM_PARTICIPANT_REQUESTS:
    "ADD_WAITING_ROOM_PARTICIPANT_REQUESTS",
  UPDATE_WAITING_ROOM_PARTICIPANT_REQUESTS:
    "UPDATE_WAITING_ROOM_PARTICIPANT_REQUESTS",
  CLEAR_EXPIRED_JOIN_REQUESTS: "CLEAR_EXPIRED_JOIN_REQUESTS",
  UPDATE_USER_ONLINE_STATUS: "UPDATE_USER_ONLINE_STATUS",
  UPDATE_CHAT_ONLINE_STATUS: "UPDATE_CHAT_ONLINE_STATUS",
  UPDATE_USER_BAN_STATUS_IN_ACTIVE_ROOM:
    "UPDATE_USER_BAN_STATUS_IN_ACTIVE_ROOM",
  UPDATE_USER_TOOLBOX_BAN_STATUS_IN_ACTIVE_ROOM:
    "UPDATE_USER_TOOLBOX_BAN_STATUS_IN_ACTIVE_ROOM",
  UPDATE_USER_MODERATORSHIP_STATUS_IN_ACTIVE_ROOM:
    "UPDATE_USER_MODERATORSHIP_STATUS_IN_ACTIVE_ROOM",
  UPDATE_USER_KICK_OUT_VOTE_IN_ACTIVE_ROOM:
    "UPDATE_USER_KICK_OUT_VOTE_IN_ACTIVE_ROOM",
  UPDATE_NEW_ROOM_PARTICIPANT_IN_ACTIVE_ROOM:
    "UPDATE_NEW_ROOM_PARTICIPANT_IN_ACTIVE_ROOM",
  UPDATE_MUTED_ROOM_PARTICIPANT_IN_ACTIVE_ROOM:
    "UPDATE_MUTED_ROOM_PARTICIPANT_IN_ACTIVE_ROOM",
  UPDATE_MESSAGE_INTERACTION_IN_ACTIVE_ROOM:
    "UPDATE_MESSAGE_INTERACTION_IN_ACTIVE_ROOM",
  UPDATE_MESSAGE_TIPPING_IN_ACTIVE_ROOM:
    "UPDATE_MESSAGE_TIPPING_IN_ACTIVE_ROOM",
  UPDATE_ROOM_TEAM_SCORE_IN_ACTIVE_ROOM:
    "UPDATE_ROOM_TEAM_SCORE_IN_ACTIVE_ROOM",
  UPDATE_USER_DATA: "UPDATE_USER_DATA",
  UPDATE_EXPIRED_ACTIVE_CHAT: "UPDATE_EXPIRED_ACTIVE_CHAT",
  TOGGLE_ROOM_TOOLBOX: "TOGGLE_ROOM_TOOLBOX",
  SET_ROOM_TOOLBOX_ENABILITY: "SET_ROOM_TOOLBOX_ENABILITY",
  MARK_ROOM_MESSAGES_READ: "MARK_ROOM_MESSAGES_READ",
  UPDATE_CHAT_PREF: "UPDATE_CHAT_PREF",
  REMOVE_CHAT: "REMOVE_CHAT",
  UPDATE_CHAT_ONLINE_STATUS: "UPDATE_CHAT_ONLINE_STATUS",
  // Optimistic message lifecycle
  ADD_OPTIMISTIC_MESSAGE: "ADD_OPTIMISTIC_MESSAGE",
  CONFIRM_OPTIMISTIC_MESSAGE: "CONFIRM_OPTIMISTIC_MESSAGE",
  FAIL_OPTIMISTIC_MESSAGE: "FAIL_OPTIMISTIC_MESSAGE",
  UPDATE_OPTIMISTIC_IMAGE_SRC: "UPDATE_OPTIMISTIC_IMAGE_SRC",
  // Message state actions
  KEEP_MESSAGE: "KEEP_MESSAGE",
  UNKEEP_MESSAGE: "UNKEEP_MESSAGE",
  EXPIRE_MESSAGES: "EXPIRE_MESSAGES",
  ADD_BLOCKED_PERIOD_MESSAGE: "ADD_BLOCKED_PERIOD_MESSAGE",
  ADD_SYSTEM_NOTICE: "ADD_SYSTEM_NOTICE",
  DELETE_MESSAGE_FOR_ME: "DELETE_MESSAGE_FOR_ME",
};

export default ACTIONS;
